import React, { useState, useEffect, useContext } from 'react';
import { CategorySpendBenchmarkContext } from '.';
import { getBenchmarkSpend } from 'utils/apiRequests';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';
import {
	defaultColDefination,
	formatPercentageToSingleDecimal,
	initialGridData,
	renderTableForSpend,
} from 'CategoryManagement/Explore/DetailedAnalysis/utils';
import { allOption } from 'CategoryManagement/utils';
import { formatNumber } from 'utils/number';

const benchmarkTextAboveSpend = `are beyond benchmark`;
const benchmarkTextWithinSpend = `are within benchmark`;

const CategorySpendBenchmarkProvider = ({ children }) => {
	const { isFetching, currentSelectCategory, dateRangeData } = useContext(
		CategoryManagementContext
	);
	const { dateFrom, dateTo } = dateRangeData;
	const [spendData, setSpendData] = useState({
		isFetching: false,
		data: {},
		analysisAboveSpend: `- ${benchmarkTextAboveSpend}`,
		analysisWithinSpend: `- ${benchmarkTextWithinSpend}`,
		gridData: initialGridData,
		errors: null,
	});

	const fetchData = async value => {
		try {
			setSpendData({ ...spendData, isFetching: true });
			const payLoad = {
				categoryName: value,
				flag: 0,
				dateFrom: dateFrom,
				dateTo: dateTo,
			};
			getBenchmarkSpend(payLoad)
				.then(response => {
					let analysisStringAboveSpend,
						analysisStringWithinSpend,
						rowResult = [],
						colResult = [];
					const categoryLevel =
						value === allOption.id ? 0 : value.split('/').length - 2;
					const dataToMap = renderTableForSpend(categoryLevel);
					if (response.succeeded) {
						if (!!Object.keys(response.data).length) {
							if (response.data.min !== null) {
								analysisStringWithinSpend = `${formatNumber(
									response.data.mincount
								)} L${categoryLevel + 1}'s ${benchmarkTextWithinSpend}`;
							} else {
								analysisStringWithinSpend = `0 L${categoryLevel +
									1}'s ${benchmarkTextWithinSpend}`;
							}
							if (response.data.max !== null) {
								analysisStringAboveSpend = `${formatNumber(
									response.data.maxcount
								)} L${categoryLevel + 1}'s ${benchmarkTextAboveSpend}`;
							} else {
								analysisStringAboveSpend = `0 L${categoryLevel +
									1}'s ${benchmarkTextAboveSpend}`;
							}

							if (response.data.excelGenerateDTO !== null) {
								if (response.data.excelGenerateDTO[dataToMap.key] !== null) {
									rowResult = response.data.excelGenerateDTO[dataToMap.key].map(
										x => {
											return {
												...x,
												client: formatPercentageToSingleDecimal(x.client),
												median: formatPercentageToSingleDecimal(x.median),
												min: formatPercentageToSingleDecimal(x.min),
												max: formatPercentageToSingleDecimal(x.max),
											};
										}
									);
									colResult = dataToMap.columnDefs;
								}
							}
							setSpendData(prevState => ({
								...prevState,
								isFetching: false,
								data: response.data,
								analysisAboveSpend: `${analysisStringAboveSpend}`,
								analysisWithinSpend: `${analysisStringWithinSpend}`,
								gridData: {
									...prevState.gridData,
									rowData: rowResult,
									columnDefs: colResult,
									defaultColDef: defaultColDefination,
								},
								errors: response.errors,
							}));
						}
					} else {
						setSpendData(prevState => ({
							...prevState,
							isFetching: false,
							data: response.data === null ? {} : response.data,
							errors: response.errors,
						}));
					}
				})
				.catch(() =>
					setSpendData(prevState => ({
						...prevState,
						isFetching: false,
						data: [],
						errors: [],
					}))
				);
		} catch (error) {
			setSpendData(prevState => ({
				...prevState,
				isFetching: false,
				data: null,
				errors: error,
			}));
		}
	};

	useEffect(
		() => {
			if (!isFetching) {
				if (!spendData.isFetching) {
					fetchData(currentSelectCategory.categoryName);
				}
			}
		}, // eslint-disable-next-line
		[isFetching, currentSelectCategory.categoryName, dateRangeData]
	);

	return (
		<CategorySpendBenchmarkContext.Provider
			value={{
				...spendData,
				fetchData,
			}}
		>
			{children}
		</CategorySpendBenchmarkContext.Provider>
	);
};

export { CategorySpendBenchmarkProvider, CategorySpendBenchmarkContext };
